import React from 'react'
import { Button, Checkbox, FormControlLabel, Paper, TextField, Typography } from '@material-ui/core'
import _ from 'lodash'
import { useIntl } from 'src/common/razzle-platform-translate'



function SpecificityFilter(props) {
    const { formatMessage } = useIntl()
    const { values, clearFilter, save, specificity, handleChange } = props
    const specType = specificity.type === 'm_list' ? 'choices' : specificity.type === 'date' ? 'date' : 'choice'
    const showClear = !_.isEmpty(values[`productSpecificities.${specType}_${specificity.id}`])

    return (
        <Paper className="p-8 pb-2" style={{ width: '20rem' }}>
            <div className="flex flex-col">
                <div className="flex items-center">
                    <Typography className="mb-4" variant="h6">
                        {specificity.name}
                    </Typography>
                </div>

                {
                    specificity.type === 'date' ?
                        <TextField
                            label={formatMessage({ id: 'Date', defaultMessage: 'Date' })}
                            type="date"
                            name={`productSpecificities.date_${specificity.id}`}
                            value={values[`productSpecificities.date_${specificity.id}`] || ''}
                            onChange={handleChange}
                            variant="outlined"
                            InputLabelProps={{ shrink: true }}
                            fullWidth
                        /> :
                        <div className="flex flex-col px-4">
                            {specificity.choices.map((choice, index) => {
                                const isChecked = values[`productSpecificities.${specType}_${specificity.id}`] && values[`productSpecificities.${specType}_${specificity.id}`].indexOf(choice.value) !== -1 ? true : false
                                return (
                                    <FormControlLabel
                                        classes={{
                                            root: index & 1 ? 'bg-gray-200' : ''
                                        }}
                                        key={index}
                                        control={<Checkbox
                                            name={`productSpecificities.${specType}_${specificity.id}`}
                                            value={choice.value}
                                            onChange={(event) => handleChange(event, true, isChecked)}
                                            checked={isChecked}
                                        />}
                                        label={<Typography>{choice.value}</Typography>}
                                    />
                                )
                            })}
                        </div>
                }

                <div className="flex items-center justify-between mt-4">
                    <div className="flex items-center">
                        {showClear && <Button onClick={() => clearFilter(`productSpecificities.${specType}_${specificity.id}`)} variant="text" className="text-gray-600">
                            <Typography>{formatMessage({ id: 'Clear', defaultMessage: 'Clear' })}</Typography>
                        </Button>}
                    </div>
                    <div className="flex items-center justify-end">
                        <Button onClick={save} variant="text">
                            <Typography>{formatMessage({ id: 'Save', defaultMessage: 'Save' })}</Typography>
                        </Button>
                    </div>
                </div>
            </div>
        </Paper>
    )
}

export default SpecificityFilter
